/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description keycloak context
 */

import React from 'react';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

export interface IKeycloakContext {
	isAuthenticated: boolean;
	keycloak: Keycloak;
	initOptions: KeycloakInitOptions;
}

export default React.createContext<IKeycloakContext>({
	isAuthenticated: false,
	keycloak: {} as Keycloak,
	initOptions: {},
});
